import { useEffect, useState } from "react";
import { apiClient } from "@/lib/auth";
import { PenSquare, Calendar, Building2, Activity } from "lucide-react";

const TYPE_META = {
  content: { icon: PenSquare, color: "from-primary to-violet-500" },
  calendar: { icon: Calendar, color: "from-blue-500 to-cyan-400" },
  profile: { icon: Building2, color: "from-emerald-500 to-blue-500" },
};

function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "à l'instant";
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
  if (diff < 604800) return `il y a ${Math.floor(diff / 86400)} j`;
  return d.toLocaleDateString("fr-FR", { day: "numeric", month: "short" });
}

export default function ActivityFeed() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.get("/activity").then(r => setItems(r.data.items || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="border border-border rounded-2xl p-6 bg-card h-full" data-testid="activity-feed">
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-muted-foreground">Activité récente</p>
          <h3 className="font-bold text-lg mt-1 flex items-center gap-2">
            <Activity className="h-4 w-4 text-primary" /> Fil de votre commerce
          </h3>
        </div>
      </div>
      {loading ? (
        <div className="space-y-3">{[...Array(4)].map((_, i) => <div key={i} className="h-12 shimmer rounded-md" />)}</div>
      ) : items.length === 0 ? (
        <div className="text-center py-10">
          <Activity className="h-8 w-8 mx-auto text-muted-foreground/50 mb-2" />
          <p className="text-sm text-muted-foreground">L'activité apparaîtra ici dès vos premières actions.</p>
        </div>
      ) : (
        <ol className="relative space-y-3">
          {items.slice(0, 6).map((it, i) => {
            const meta = TYPE_META[it.type] || TYPE_META.content;
            const Icon = meta.icon;
            return (
              <li key={i} className="flex items-start gap-3 group" data-testid={`activity-${i}`}>
                <div className={`h-8 w-8 rounded-md bg-gradient-to-br ${meta.color} flex items-center justify-center text-white shrink-0`}>
                  <Icon className="h-3.5 w-3.5" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <p className="font-semibold text-sm truncate">{it.title}</p>
                    <span className="text-xs text-muted-foreground shrink-0">{timeAgo(it.at)}</span>
                  </div>
                  <p className="text-xs text-muted-foreground truncate">
                    {it.detail}{it.meta ? ` · ${it.meta}` : ""}
                  </p>
                </div>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
